// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-menu-list__item:not(:first-child){margin-top:20px}.footer-menu-list__link{display:block;color:var(--z2kad5);font-size:14px;line-height:18px;transition:color .2s ease-in}.footer-menu-list__link:hover{color:var(--7k9zs9)}.footer-menu-list--main .footer-menu-list__link{font-weight:500}.the-footer{position:relative;z-index:1}.the-footer .footer-bottom{background-color:#fff}", ""]);
// Exports
module.exports = exports;
